import React from 'react';

import { Flex, Text, Icon } from 'Components/Base';
import { getConfig } from 'Util/Config';
import { isInBetween } from 'Util/DateUtils';

const appNotification = getConfig().appNotification;

const AppNotification = () => {
  const { message, active, startDate = '', endDate = '' } = appNotification || {};
  const isDateValid = isInBetween(startDate, endDate);
  const show = active && isDateValid;

  return (
    show && (
      <Flex bg={'primary'} p={2} justifyContent={'center'}>
        <Icon name={'notification_important'} color={'white'} mr={2} />
        <Text.Subtitle color={'white'}>{message}</Text.Subtitle>
      </Flex>
    )
  );
};

export default AppNotification;
